import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import "./Style.css";
import AiLeadsTable from "../../Components/AiLeads/Table/Table";
import LeadsFilter from "../../Components/AiLeads/Filter/LeadsFilter";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import {
  APISalesforceUrl,
  APIDataUrl,
  APITokenUrl,
  GetUserId,
} from "../../Utils/Utils";
import HeaderSearch from "../../Components/Header/Search/Search";
const AILeads = () => {
  const [tableCommingData, setTableCommingData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [hasMore, setHasMore] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState([]);
  const [istableDataFilter, setIstableDataFilter] = React.useState(false);
  const [currentLeadsLength, setCurrentLeadsLength] = React.useState("");
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = useState(false);
  const [isSalesForceTrigger, setIsSalesForceTrigger] = useState(false);
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = useState(10);
  const [showData, setShowData] = React.useState([]);
  const [showlast, setShowlast] = React.useState([]);
  const [jScoredata, setJscore] = React.useState(["50-70", "70-90", "90-100"]);
  const [selectedCountries, setSelectedCountries] = React.useState([]);
  const [statsCount, setStatsCount] = useState(0);
  const [leadsProfileData, setLeadsProfileData] = useState([]);
  const [archiveRecord, setArchiveRecord] = useState(false);
  const [trackRecord, setTrackRecord] = useState(false);
  const [selectedOuterRows, setSelectedOuterRows] = useState([]);
  const [trackingData, setTrackingData] = useState([]);
  const [disableTracking, setDisableTracking] = useState(false);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
  const [skip, setSkip] = React.useState(0);
  const [profileRecords, setProfileRecords] = React.useState(false);
  const [selectedProfile, setSelectedProfile] = React.useState();
  const [showSalesForce, setShowSalesForce] = useState("false");
  const [addToFav, setAddToFav] = useState(false);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const loadMore = () => {
    // setLoading(true);
    setSkip((page) => page + 1);
    setTimeout(() => {
      // setLoading(false);
    }, 1000);
  };
  const perPage = 50;
  const userId = GetUserId();
  const validateFilters = () => {
    if (
      !selectedCountries?.length &&
      !selectedData?.length &&
      !showlast?.length &&
      !jScoredata?.length
    ) {
      toast.error("Please Select Filters");
      return false;
    }
    return true;
  };
  const duplicateApply = (e) => {
    setLoading(true);
    // if (e != "reset") {
    //   if (!validateFilters()) return;
    // }
    setSelectedProfile([]);
    setProfileRecords(false);
    const data = {};
    data.categories = selectedData;
    data.revenue_range = showlast;
    data.j_score = jScoredata;
    data.country = selectedCountries;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/apply_org_filter?user_id=${userId}&limit=${perPage}&skip=${
        (page - 1) * 50
      }`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((e) => {
        setTimeout(() => setLoading(false), 100);
        setTotalPages(10);
        const comingData = e?.data?.data;
        const statsCount = e?.data?.count;
        setStatsCount(statsCount);
        setPage(1);
        if (comingData.length === 0 || comingData.length % 50 !== 0) {
          setHasMore(false);
        } else {
          setTimeout(() => {
            setHasMore(true);
          }, 1000);
        }
        if (page > 1) {
          setTableCommingData(comingData);
        } else {
          setTableCommingData(comingData);
        }
        if (comingData.length === 0) {
          setHasMore(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleApply = (e) => {
    // if (!validateFilters()) return;
    // if (statsCount <= tableCommingData.length) return;
    // if (loading) return;
    setLoading(true);
    setHasMore(false);
    const data = {};
    data.categories = selectedData;
    data.revenue_range = showlast;
    data.j_score = jScoredata;
    data.country = selectedCountries;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/apply_org_filter?user_id=${userId}&limit=${perPage}&skip=${
        (page - 1) * 50
      }`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((e) => {
        setTimeout(() => setLoading(false), 100);
        const comingData = e?.data?.data.sort(
          (a, b) => b.ai_score - a.ai_score,
        );
        const statsCount = e?.data?.count;
        setStatsCount(statsCount);
        if (comingData.length % 50 !== 0 || comingData.length === 0) {
          setHasMore(false);
        } else {
          setTimeout(() => {
            setHasMore(true);
          }, 1000);
        }
        if (page > 1) {
          setTableCommingData((prevData) => [...prevData, ...comingData]);
        } else {
          setTableCommingData(comingData);
        }
        if (comingData.length === 0) {
          setHasMore(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (page > 0) {
  //       if (tableCommingData?.length && profileRecords) {
  //         applyFilterProfile();
  //       }else if(tableCommingData?.length){
  //         handleApply();
  //       }
  //     }
  //   }, 150)
  // }, [page])
  const LeadsProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_public_filter_org`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          setLeadsProfileData(e?.data?.data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    LeadsProfile();
  }, []);
  const handleProfileFilterData = (item) => {
    setJscore([]);
    setSelectedProfile(item);
    setProfileRecords(true);
    setPage(1);
  };
  const applyFilterProfile = async () => {
    setLoading(true);
    const formatedDateFrom = moment(selectedProfile?.fundingDate).format(
      "YYYY-MM-DD",
    );
    const formatedDateTo = moment(selectedProfile?.fundingDateAt).format(
      "YYYY-MM-DD",
    );
    const minFundingRounds = parseInt(selectedProfile?.num_funding_rounds_min);
    const maxFundingRounds = parseInt(selectedProfile?.num_funding_rounds_max);
    const TotalFundingRounds = [minFundingRounds, maxFundingRounds];
    const data = {};
    data.categories = selectedProfile?.categories
      ? [selectedProfile?.categories]
      : null;
    data.user_id = selectedProfile?.user_id;
    data.revenue_range = selectedProfile?.revenue_range
      ? selectedProfile?.revenue_range
      : null;
    data.num_employees = selectedProfile?.num_employees
      ? selectedProfile?.num_employees
      : null;
    data.state = selectedProfile?.state ? selectedProfile?.state : null;
    data.country = selectedProfile?.country ? [selectedProfile?.country] : null;
    data.ipo_status = selectedProfile?.ipo_status
      ? selectedProfile?.ipo_status
      : null;
    data.last_equity_funding_type = selectedProfile?.last_funding_type
      ? selectedProfile?.last_funding_type
      : null;
    // data.last_funding_at_from = formatedDateFrom === 'Invalid date' ? null : formatedDateFrom;
    // data.last_funding_at_to = formatedDateTo === 'Invalid date' ? null : formatedDateTo;
    data.num_funding_rounds =
      minFundingRounds || maxFundingRounds ? TotalFundingRounds : null;
    data.last_funding_total = selectedProfile?.last_funding_total
      ? selectedProfile?.last_funding_total
      : null;
    data.j_score = selectedProfile?.j_score ? [selectedProfile?.j_score] : null;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/apply_org_filter?user_id=${userId}&limit=50&skip=${
        (page - 1) * 50
      }`,
      data: JSON.stringify(data),
    };
    axios(option)
      .then((e) => {
        setTimeout(() => setLoading(false), 100);
        if (e?.data?.count < 50) {
          setTotalPages(1);
        } else {
          setTotalPages(10);
        }
        const comingData = e?.data?.data;
        const statsCount = e?.data?.count;
        setStatsCount(statsCount);
        if (comingData.length === 0 || comingData.length % 50 !== 0) {
          setProfileRecords(false);
          setHasMore(false);
        } else {
          setTimeout(() => {
            setProfileRecords(true);
            setHasMore(true);
          }, 1000);
        }

        if (page > 1) {
          setTableCommingData((prevdata) => [...prevdata, ...comingData]);
        } else {
          setTableCommingData(comingData);
        }

        if (comingData.length === 0) {
          setHasMore(false);
          setProfileRecords(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    handleTrackingdata();
  }, []);

  // useEffect(() => {
  //   if (trackingData.length > 0 && selectedOuterRows.length > 0) {
  //     const isMatching = trackingData.some((trackingItem) =>
  //       selectedOuterRows.some(
  //         (selectedItem) => Number(selectedItem.org_id) === Number(trackingItem.org_id)
  //       )
  //     );

  //     setDisableTracking(isMatching);
  //   } else {
  //     setDisableTracking(false);
  //   }
  // }, [trackingData, selectedOuterRows]);

  useEffect(() => {
    if (trackingData.length > 0 && selectedOuterRows.length > 0) {
      const isMatching = selectedOuterRows.every((selectedItem) =>
        trackingData.some(
          (trackingItem) =>
            Number(selectedItem.org_id) === Number(trackingItem.org_id),
        ),
      );

      setDisableTracking(isMatching);
    }
  }, [trackingData, selectedOuterRows]);
  const [sortOrder, setSortOrder] = React.useState("");
  const [sortField, setSortField] = React.useState("");
  const [data, setData] = React.useState([]);

  const resetSortData = () => {
    setSortOrder(null);
    setSortField("");
  };
  const handleSort = (field, sorting) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sorting ? sorting : sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = sorting ? sorting : "asc";
    }

    setSortOrder(newSortOrder);
    setSortField(field);

    const employeeOrder = [
      "1-10",
      "11-50",
      "51-100",
      "101-250",
      "251-500",
      "501-1000",
      "1K-5K",
      "5K-10K",
      "10K+",
    ];

    const revenueOrder = [
      "$0-$1m",
      "$0-$1M",
      "$1m-$10m",
      "$1M-$10M",
      "$10m-$50m",
      "$10M-$50M",
      "$50m-$100m",
      "$50M-$100M",
      ,
      "$100m-$500m",
      "$100M-$500M",
      "$500m-$1b",
      "$500M-$1B",
      "$1b-$10b",
      "$1B-$10B",
      "$10b+",
      "$10B+",
    ];

    const getOrderIndex = (value, orderArray) => {
      const index = orderArray.indexOf(value);
      return index !== -1 ? index : orderArray.length;
    };

    const sortedData = [...data].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1;
      if (!aIsEmpty && bIsEmpty) return -1;
      if (aIsEmpty && bIsEmpty) return 0;

      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (field === "num_employees") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, employeeOrder) -
              getOrderIndex(bValue, employeeOrder)
          : getOrderIndex(bValue, employeeOrder) -
              getOrderIndex(aValue, employeeOrder);
      }

      if (field === "revenue_range") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, revenueOrder) -
              getOrderIndex(bValue, revenueOrder)
          : getOrderIndex(bValue, revenueOrder) -
              getOrderIndex(aValue, revenueOrder);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });
    setData(sortedData);
  };
  return (
    <>
      <Layout>
        {loading ? <Loader /> : null}
      <div className="child-section-of-everypage  ">
        <AiLeadsAction
          disableTracking={disableTracking}
          currentLeadsLength={currentLeadsLength}
          setIsDecisionMakerExcel={setIsDecisionMakerExcel}
          setIsSalesForceTrigger={setIsSalesForceTrigger}
          isSalesForceTrigger={isSalesForceTrigger}
          statsCount={statsCount}
          setArchiveRecord={setArchiveRecord}
          setTrackRecord={setTrackRecord}
          setRequestUpdateRecord={setRequestUpdateRecord}
          disableRequestUpdate={disableRequestUpdate}
          showSalesForce={showSalesForce}
          setAddToFav={setAddToFav}
        />
        <LeadsFilter
          applyFilterProfile={handleProfileFilterData}
          selectedCountries={selectedCountries}
          setSelectedCountries={setSelectedCountries}
          showlast={showlast}
          setShowlast={setShowlast}
          setJscore={setJscore}
          jScoredata={jScoredata}
          selectedData={selectedData}
          showData={showData}
          setShowData={setShowData}
          setSelectedData={setSelectedData}
          handleApply={(e) => {
            duplicateApply(e);
          }}
          tableCommingData={tableCommingData}
          setTableCommingData={setTableCommingData}
          istableDataFilter={istableDataFilter}
          setIstableDataFilter={setIstableDataFilter}
          setStatsCount={setStatsCount}
          setPage={setPage}
          leadsProfileData={leadsProfileData}
          setSelectedProfile={setSelectedProfile}
          setProfileRecords={setProfileRecords}
        />
        <AiLeadsTable
          handleTrackingdata={handleTrackingdata}
          setDisableTracking={setDisableTracking}
          trackingData={trackingData}
          selectedOuterRows={selectedOuterRows}
          setSelectedOuterRows={setSelectedOuterRows}
          handleApply={handleApply}
          tableCommingData={tableCommingData}
          setTableCommingData={setTableCommingData}
          istableDataFilter={istableDataFilter}
          setCurrentLeadsLength={setCurrentLeadsLength}
          setIstableDataFilter={setIstableDataFilter}
          isSalesForceTrigger={isSalesForceTrigger}
          isDecisionMakerExcel={isDecisionMakerExcel}
          setIsDecisionMakerExcel={setIsDecisionMakerExcel}
          setPage={setPage}
          page={page}
          archiveRecord={archiveRecord}
          setArchiveRecord={setArchiveRecord}
          trackRecord={trackRecord}
          setTrackRecord={setTrackRecord}
          requestUpdateRecord={requestUpdateRecord}
          setRequestUpdateRecord={setRequestUpdateRecord}
          setDisableRequestUpdate={setDisableRequestUpdate}
          profileRecords={profileRecords}
          setProfileRecords={setProfileRecords}
          applyFilterProfile={applyFilterProfile}
          selectedProfile={selectedProfile}
          setShowSalesForce={setShowSalesForce}
          totalPagesout={totalPages}
          setAddToFav={setAddToFav}
          addToFav={addToFav}
          setIsSalesForceTrigger={setIsSalesForceTrigger}
          handleSort={handleSort}
          sortOrder={sortOrder}
          sortField={sortField}
          data={data}
          setData={setData}
        />
      </div>
      </Layout>
    </>
  );
};
export default AILeads;
